import React from 'react';

import Grid from '@mui/material/Grid';

import { Subject } from 'modules/subjects/types';

import { Exercise } from '../../types';

import AvailableExercisesPanel from './AvailableExercisesPanel';
import SelectedExercisesPanel from './SelectedExercisesPanel';

export interface ExercisesSelectorProps {
  subjects?: Subject[];
  loadingSubjects?: boolean;

  selectedExercises: Exercise[];
  isExerciseSelected: (exercise: Exercise) => boolean;

  onAddExercise: (exercise: Exercise) => void;
  onAddExercises: (exercises: Exercise[]) => void;

  onRemoveExercise: (exercise: Exercise) => void;
  onRemoveAllExercises: () => void;

  onSortExercises: (from: number, to: number) => void;
}

const ExercisesSelector = (props: ExercisesSelectorProps) => {
  const {
    subjects,
    loadingSubjects,
    isExerciseSelected,
    onAddExercise,
    onAddExercises,
    onRemoveAllExercises,
    onRemoveExercise,
    onSortExercises,
    selectedExercises,
  } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <AvailableExercisesPanel
          subjects={subjects}
          loadingSubjects={loadingSubjects}
          onAddExercise={onAddExercise}
          onAddExercises={onAddExercises}
          onRemoveExercise={onRemoveExercise}
          isExerciseSelected={isExerciseSelected}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectedExercisesPanel
          exercises={selectedExercises}
          onRemoveExercise={onRemoveExercise}
          onRemoveAllExercises={onRemoveAllExercises}
          onSortExercises={onSortExercises}
        />
      </Grid>
    </Grid>
  );
};

export default ExercisesSelector;
